import { apiClient } from './apiClient';

export type JobPositionAttributionKind = {
  id: string;
  name: string;
  description: string;
  sortOrder: number;
  isSystem: boolean;
  isActive: boolean;
  createdAtUtc: string;
  updatedAtUtc: string;
};

export type JobPositionAttributionKindUpsertPayload = {
  name: string;
  description?: string;
  sortOrder?: number;
  isActive?: boolean;
};

export async function listJobAttributionKinds(
  activeOnly = false,
): Promise<JobPositionAttributionKind[]> {
  const response = await apiClient.get<JobPositionAttributionKind[]>(
    '/v1/people/job-attribution-kinds',
    { params: { activeOnly } },
  );
  return response.data;
}

export async function createJobAttributionKind(
  payload: JobPositionAttributionKindUpsertPayload,
): Promise<JobPositionAttributionKind> {
  const response = await apiClient.post<JobPositionAttributionKind>(
    '/v1/people/job-attribution-kinds',
    payload,
  );
  return response.data;
}

export async function updateJobAttributionKind(
  id: string,
  payload: JobPositionAttributionKindUpsertPayload,
): Promise<JobPositionAttributionKind> {
  const response = await apiClient.put<JobPositionAttributionKind>(
    `/v1/people/job-attribution-kinds/${id}`,
    payload,
  );
  return response.data;
}

export async function deleteJobAttributionKind(id: string): Promise<void> {
  await apiClient.delete(`/v1/people/job-attribution-kinds/${id}`);
}
